import { VgApiResult, vgApiRequest } from "./vg-api.service";

export type UserOrganisation = {
  orgId: number;
  orgName: string;
};

type ReadAllUserOrgsResponse = {
  completeOrgList?: UserOrganisation[];
};

/**
 * POST `Read_All_User_Organisations` — returns organisations the signed-in user can access.
 * A failed request comes back as `{ data: null, error }`, so callers can tell it apart
 * from a user who genuinely has no organisations (`{ data: [], error: null }`).
 */
export async function fetchUserOrganisations(
  accessToken: string
): Promise<VgApiResult<UserOrganisation[]>> {
  const { data, error } = await vgApiRequest<ReadAllUserOrgsResponse>(
    accessToken,
    "Read_All_User_Organisations",
    {}
  );
  if (error) {
    console.warn("Read_All_User_Organisations failed", error);
    return { data: null, error };
  }
  const list =
    data?.completeOrgList ??
    (data as { CompleteOrgList?: UserOrganisation[] })?.CompleteOrgList ??
    [];
  return {
    data: list.map((o) => ({
      orgId: Number(o.orgId),
      orgName: String(o.orgName ?? ""),
    })),
    error: null,
  };
}
